import { Box } from '@withjoy/joykit';
import React from 'react';

interface BlurWrapperProps {
  isBlurred: boolean;
  isEnabled: boolean;
  children: React.ReactNode;
  inset?: { top: number; right: number; bottom: number; left: number };
}

export const BlurWrapper: React.FC<BlurWrapperProps> = ({ isBlurred, isEnabled, children, inset = { top: 0, right: 0, bottom: 0, left: 0 } }) => {
  if (!isEnabled) {
    return <>{children}</>;
  }

  return (
    <Box
      position="relative"
      width="100%"
      height="100%"
      __css={{
        '&::after': isBlurred
          ? {
              content: '""',
              position: 'absolute',
              inset: 0,
              ...inset,
              backdropFilter: 'blur(12px)',
              zIndex: 10,
              pointerEvents: 'none',
            }
          : {},
      }}
    >
      {children}
    </Box>
  );
};
